import axios from 'axios';
import {
	GET_FACILITY_SUCCESS,
	GET_FACILITY_FAILED,
	SET_ALERT,
	CREATE_FACILITY_SUCCESS,
	CREATE_FACILITY_FAILED,
	GET_ALL_FACILITY_SUCCESS,
	GET_ALL_FACILITY_FAILED,
	UPDATE_FACILITY_SUCCESS,
	UPDATE_FACILITY_FAILED,
} from './index';

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export const getAllFacilities = (offset) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		const response = await axios.get(
			BASE_URL + '/api/get-facilities?offset=' + offset,
			config
		);
		dispatch({ type: GET_FACILITY_SUCCESS, payload: response.data });
	} catch (e) {
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Failed to retrieve facility', status: 'error' },
		});
		dispatch({ type: GET_FACILITY_FAILED });
	}
};

export const saveFacility =
	({
		name: name,
		state: state,
		address: address,
		city,
		zip,
		fishbowl_customer_name,
		fishbowl_tax_rate_name,
	}) =>
	async (dispatch: any) => {
		const config = {
			headers: {
				'x-auth-token': localStorage.getItem('x-auth-token'),
			},
		};
		try {
			const response = await axios.post(
				BASE_URL + '/api/post-facilities',
				{
					name: name,
					state: state,
					address: address,
					city,
					zip,
					fishbowl_customer_name,
					fishbowl_tax_rate_name,
				},
				config
			);
			dispatch({ type: CREATE_FACILITY_SUCCESS, payload: response.data });
			dispatch({
				type: SET_ALERT,
				payload: { message: 'Facility created successfully!', status: 'success' },
			});
		} catch (e) {
			dispatch({ type: CREATE_FACILITY_FAILED });
			dispatch({
				type: SET_ALERT,
				payload: {
					message: e.response?.data?.error || 'Failed to create facility',
					status: 'error',
				},
			});
			throw e;
		}
	};

export const getAllFacilityList = () => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		const response = await axios.get(BASE_URL + '/api/get-all-facilities', config);
		dispatch({ type: GET_ALL_FACILITY_SUCCESS, payload: response.data });
	} catch (e) {
		dispatch({ type: GET_ALL_FACILITY_FAILED });
	}
};

export const editFacility = (facilityData) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		const response = await axios.put(
			`${BASE_URL}/api/put-facilities/${facilityData.facilityId}`,
			facilityData,
			config
		);
		dispatch({ type: UPDATE_FACILITY_SUCCESS, payload: response.data });
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Facility updated successfully!', status: 'success' },
		});
		return true;
	} catch (e) {
		dispatch({ type: UPDATE_FACILITY_FAILED });
		dispatch({
			type: SET_ALERT,
			payload: {
				message: e.response?.data?.error || 'Failed to update facility',
				status: 'error',
			},
		});
		return false;
	}
};
